import React, { useState, useEffect, useMemo } from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import _, { isEmpty, get, cloneDeep } from 'lodash';
import { Button, message, Steps, theme } from 'antd';
import BasicDetails from '../components/BasicDetails';
import CustomPlans from '../components/CustomPlans';
import moment from 'moment';
import routes from '../../../../routes';
import { withRouter, Link } from 'react-router-dom';
import {
  PreviewDataAction,
  getCampaignListAction,
  postBasicDetailsSubmitAction, postCampaignNameListAction, postCustomDetailsAction, postValidateStrategyAction,
} from '../../../../actions';
import { strategyCreativeDataAction, postCampaignDataAction } from '../../../../actions/creative';
import ToastModal from "../../../../components/ToastModal";
import RecommendedPlans from '../components/RecommendedPlans';
import Strategy from '../components/StrategyParent/Strategy';
import CustomStrategy from '../components/StrategyParent/CustomStrategy/List';
import RecommendStrategy from '../components/StrategyParent/CustomStrategy/AddStrategy';
import Creative from '../components/Creative';
import PreviewPublish from '../components/PreviewPublish';
import { getTenantTimeZone, getUserSelectedDateInUtc, getUserSelectedDateInUtcForEndDate, isApiCallSuccess, isDemoCampaign, isTenantDemoAdvertiser } from '../../../../selectors';
import { basicDetailsReduxAction } from '../../../../actions/basicDetails';
import { customPlanReduxAction, setStepperEditAction } from '../../../../actions/customPlanDetails';
import { setLocationReduxAction, strategyListReduxAction } from '../../../../actions/strategyDetails';
import { setPreferenceListReduxAction } from '../../../../actions/recommendedPlan';
// import { strategyPayloadAction } from '../../../../actions/strategyDetails';
import asyncRoute from '../../../../helpers/hoc/asyncRoute';
import { getThirdPartyAccountAction, getCampaignAction, postCampaignAction, reduxCampaignDataAction, reduxCampaignPreviewPublishDataAction, reduxDataForAccordianOpenCampaignAction, reduxDataForStrategyAction } from '../../../../actions/campaign';
import { campaignMessages } from '../components/CustomPlanStrategy/constant';
// import { strategyPayloadAction } from '../../../../actions/strategyDetails';
import { Modal } from 'antd';
import { useFetchAccountThirdPartySeats } from '../../../../hooks/useFetchAccountThirdPartySeats';
import { infoMessages } from '../../../../constants/demo/constant';
import { campaignList, campaignListPreview, recoCampaignListPreview, recoCampaignStrategyList, recoCampaignStrategyTypeReco, recoCreativeEditResponse } from '../../../../constants/demo/campaignData';
const CustomPlanStrategy = asyncRoute(() => import('../components/CustomPlanStrategy'));
const AddNewStrategy = asyncRoute(() => import("../components/AddNewStrategy"));

const steps = [
  {
    title: 'Basic Details',
    content: 'BasicDetails',
  },
  {
    title: 'Custom Plans & Strategy',
    content: "CustomPlans",
  },
  // {
  //   title: 'Strategy',
  //   content: "CustomStrategy",
  // },
  // {
  //   title: 'Creative',
  //   content: "Creative",
  // },
  {
    title: 'Preview & Publish',
    content: "PreviewPublish",
  },
];

const RecommendedSteps = [
  {
    title: 'Basic Details',
    content: 'BasicDetails',
  },
  {
    title: 'Recommended Plans',
    content: "RecommededPlans",
  },
  {
    title: 'Set Your Preferences',
    content: "RecommendedStrategy",
  },
  {
    title: 'Creative',
    content: "Creative",
  },
  {
    title: 'Preview & Publish',
    content: "PreviewPublish",
  },
];

const StepTwoContent = () => {
  return <div>Second Content</div>;
};

const StepThreeContent = () => {
  return <div>Last Content</div>;
};



const App = (props) => {
  const [isPublishButton, setIsPublishButton] = useState(false);
  const [enableToast, setEnableToast] = useState(false);
  const [toastStatus, setToastStatus] = useState("");
  const [toastMsg, setToastMsg] = useState("");
  const [confirmationMsg, setConfirmationMsg] = useState("");
  const { token } = theme.useToken();
  const [current, setCurrent] = useState(-1);
  const [showStepper, setShowStepper] = useState(true);
  const [isBasicDetailsComplete, setIsBasicDetailsComplete] = useState(false);
  const [basicDetailsForm, setBasicDetailsInParent] = useState({});
  // const [customDetailsForm, setCustomDetailsForm] = useState({});
  const [basicDetalsSubmit, setBasicDetalsSubmit] = useState({});
  const [campaignId, setCampaignId] = useState({});
  const [strategyData, setStrategyData] = useState({});
  const [strategyNext, setStrategyNext] = useState(0);
  const [creativePayloadDetails, setCreativePayloadDetails] = useState({
    valid: false,
    data: {},
    dataForRedux: {},
    isAddApi: true
  });
  const [campaignToPublishDetails, setCampaignToPublishDetails] = useState({
    isSaveEnabled: false,
    payload: {},
  });
  const [previewValidateDetails, setPreviewValidateDetails] = useState({
    data: [],
    dataForRedux: {},
    nameData: [],
    nameDataForRedux: {},
    saveDraft: [],
    campaignNameRequest: {},
  });
  const [childCampaignData, setChildCampaignData] = useState({
    childCampaignId: -1,
    isChildEdit: false,
    isRecomended: false
  })
  const [IsPreviewValid, setPreviewValid] = useState(false);
  const [summary, setSummary] = useState([]);
  const [isStatusChanged, setIsStatusChanged] = useState(false);
  const [isViewCampaign, setIsViewCampaign] = useState(props.location.pathname.includes(routes.campaign.view));
  const accountThirdpartySeats = useFetchAccountThirdPartySeats();
  const expiredSeats = Array.isArray(accountThirdpartySeats) ? accountThirdpartySeats.filter(seat => seat.isExpired == 1) : [];
  const expiredSeatIds = expiredSeats.map(seat => seat.accountId);

  // console.log("previewValidateDetails", previewValidateDetails)


  const tenantId = useSelector(state => get(state, 'app.preSignInState.tenantId', ''));
  const userId = useSelector(state => get(state, 'app.preSignInData.userId', ''));
  const authToken = useSelector(state => get(state, 'app.signInData.authToken', ''));
  const basicDetailsReduxForm = useSelector(state => get(state, 'app.basicDetailsForm', {}));
  const customDetailsForm = useSelector(state => get(state, 'app.customPlanData.customDetailsForm', {}));
  const stepperData = useSelector(state => get(state, 'app.stepperData', ''));
  const recommendedPlanData = useSelector(state => get(state, 'app.recommendedPlanData', ''));
  const reduxStrategyData = useSelector(state => get(state, 'app.addStrategyData', ''));
  // const reduxStrategyData1 = useSelector(state => console.log(state, "STATE"));
  const previewScreenCampaingData = useSelector(state => get(state, 'app.previewCampaingData', []));
  const campaignPublishData = useSelector((state) => get(state, "app.campaignPublishData", []));


  // const targetTimeZone = "Asia/calcutta";
  // const targetTimeZone = "Pacific/Pago_Pago";
  // const targetTimeZone = "America/Sao_Paulo";
  const targetTimeZone = getTenantTimeZone(tenantId);

  const dispatch = useDispatch();

  // const app = useSelector(state => {
  //   console.log("123", state);
  //   return get(state, 'app', '');
  // });

  // console.log("123 ---ReduxAPP", app);

  // console.log("123 stepper start customDetailsForm", customDetailsForm)
  // console.log("customPlanData", customPlanData)
  // console.log(current)
  // localStorage.setItem('currentStep', JSON.stringify(current));

  const { match: { params: { id } } } = props;
  // useEffect(() => {
  //   const isRecommendedPlan = localStorage.getItem('isRecommendedPlan');
  //   if (isRecommendedPlan == 'true' && id) {
  //     setCurrent(2);
  //   }
  // }, [id]);

  // useEffect(() => {
  //   // console.log("123 stepperData", stepperData)
  //   if (stepperData && stepperData.screen == "editSecondary") {
  //     // console.log("123 stepperData.screen", stepperData)
  //     setCurrent(stepperData.stepperValue)
  //     // console.log("current", current)
  //   }
  //   else if (stepperData) {
  //     setCurrent(stepperData.stepperValue)
  //   }
  // }, [stepperData])

  const isDemoAdvertiser = useMemo(() => {
    return isTenantDemoAdvertiser(tenantId);
  }, [tenantId]);


  const isRecomendedPlanCampaign = useMemo(() => {

    return childCampaignData.isRecomended;

  }, [childCampaignData])


  useEffect(() => {
    const validateCampaignType = async () => {
      dispatch(reduxDataForStrategyAction({ data: {} }))
      dispatch(
        setLocationReduxAction({
          includedLocation: [],
          excludedLocation: []
        })
      );
      const { location, match: { params: { id } } } = props;

      // Check if location and location.state exist and if location.state.data exists
      const data = location && location.state && location.state.data ? location.state.data : {};
      // console.log(data, "dataaaa", id)
      // Check if id is present
      if (!id) {
        // If id is not present, set child campaign data
        setChildCampaignData(data);
        setCurrent(0);
        return;
      }

      // If id is present and data indicates this is a child edit, set current to 1 and child campaign data
      if (data.isChildEdit) {
        setCurrent(1);
        setChildCampaignData(data);
        return;
      }

      if (data.objectForCampaignPublish) {
        generateCampaignDataForPublishPage(data.objectForCampaignPublish)
        handleCampaignForPreview(data.objectForCampaignPublish);
        return;
      }

      // If id is present and data does not indicate a child edit, validate the campaign
      dispatch(
        basicDetailsReduxAction({
          basicDetailsForm: {}
        })
      );
      validateCampaign();
    };

    validateCampaignType()
  }, [])

  const validateCampaign = async () => {
    const { match: { params: { id } }, getCampaignAction, tenantId, authToken, userId } = props;

    let obj = {
      childCampaignId: -1,
      isChildEdit: false,
      isRecomended: false
    }
    let params = {
      action: "type",
      id: id
    }

    // compare static data campaign id for recomended campaign
    if (isDemoAdvertiser) {
      if (props.location.pathname.includes("view-campaign") || props.location.pathname.includes("edit-campaign")) {

        const item = campaignList.find(item => item.campaignId == id);
        if (item) {
          if (item.isReco) {
            obj.isRecomended = true
            setCurrent(2);
          } else {
            setCurrent(0);
          }
          setChildCampaignData(obj)
        } else {
          getCampaigns()
        }
        return;
      } else {
        getCampaigns()
        return
      }
    }

    async function getCampaigns() {
      const { responseCode: { msg = "", status = "" }, responseObj = {} } = await getCampaignAction({ tenantId, authToken, userId, params })

      if (isApiCallSuccess(status) && responseObj && responseObj.isReco) {
        if (responseObj.isReco) {
          obj.isRecomended = true
          if (responseObj.campaignCount == 0) {
            setCurrent(1);
          }
          else {
            setCurrent(2);
          }
        }
      }
      else {
        setCurrent(0);
      }
      setChildCampaignData(obj)
    }
    getCampaigns()
  }


  useEffect(() => {
    // console.log(previewScreenCampaingData, "Data");
    const data = previewScreenCampaingData.reduce((acc, curr) => acc.concat(curr), []);
    if (data.length > 0) {
      const specificKeys = ['id', 'name', 'accountId']; // Specify the keys you want to include

      const newArray = data.map(item => {
        const newObj = {};
        specificKeys.forEach(key => {
          newObj[key] = item[key];
        });
        return newObj;
      });

      let campaignNameRequest = {};
      const platname = data.map(({ platformName }) => platformName);
      const finalData = (_.uniq(platname) || []).map(item => {
        let campaignName = [];
        let item2 = data.filter(item1 => item1.platformName == item)
        if (item2.length > 0) {
          const hit = item2.find(item => item.accountId)
          if (hit) {
            item2 = item2.map(item => ({ ...item, accountId: hit.accountId }));
          }
          item2.forEach(items => {
            campaignName.push(items.name);
          })
          campaignNameRequest = {
            ...campaignNameRequest,
            [item]: {
              'bekiAccountId': item2[0].bekiAccountId,
              platformId: item2[0].platformId,
              mccAccountId: item2[0].mccAccountId,
              accountId: item2[0].accountId,
              campaignName,
            }
          }
        }
        return item2
      })
      // console.log(finalData, "campaignNameRequestcampaignNameRequest");
      setPreviewValidateDetails(prev => ({
        ...prev,
        data: finalData.flat(),
        saveDraft: newArray || [],
        campaignNameRequest,
      }))
    }
  }, [previewScreenCampaingData]);




  const handleBasicDetailsCompletion = (isComplete) => {
    setIsBasicDetailsComplete(isComplete);
  };

  const generateCampaignDataForPublishPage = (dataToSet) => {
    setCampaignToPublishDetails(dataToSet)
  }

  const handleCampaignForPreview = async (publishData = null) => {
    const params = {
      list: "preview"
    }

    if (publishData && publishData.status) {
      setIsStatusChanged(true)
    }

    if (isDemoAdvertiser) {
      if (props.location.pathname.includes('view-campaign') || props.location.pathname.includes('edit-campaign')) {
        const { match: { params: { id } } } = props;
        let data = []
        campaignListPreview.forEach((obj, idx) => {
          obj.response.forEach((item) => {
            if (item.mandateId == id) {
              data.push(obj);
            }
          })
        })

        if (data.length == 0) {
          let res = handleThirdPartyApis();
          data.push(res)
        }

        const {
          response = [],
          responseObj = {},
          isSynced = 0,
        } = data[0]



        // console.log(response, "response")

        dispatch(reduxCampaignPreviewPublishDataAction({ data: response }))
        setPreviewValid(false)
        if (publishData) {
          setCurrent(2)
        }
        else {
          next();
        }
        return
      }
    }
    // const flag = !campaignPublishData.every(campaign => campaignToPublishDetails.payload.campaignIds.includes(campaign.id));
    // console.log(campaignPublishData, "XXX", campaignToPublishDetails.payload, "FLAG", flag)

    // if (flag || campaignToPublishDetails.payload.campaignIds.length > campaignPublishData.length) {

    async function handleThirdPartyApis() {
      let res = {};
      await dispatch(getThirdPartyAccountAction({ tenantId, authToken, userId })).then(async (data) => {
        const {
          responseCode: { status = "" },
          responseObj,
        } = data;
        // console.log(data, 'DATA DEBUGGER');
        if (status === "Success") {
          // DATA ALREADY IN REDUX STORE THROUGH THIRD PARTY API CALL
          // if data is passed from parent then do not need to call Api Again just filter, else call Api ****************************
          if (publishData && publishData.publishDataAll) {
            const campaignIds = publishData.payload.campaignIds.map((id) => parseInt(id));
            const filterCampaignData = publishData.publishDataAll.filter((data) => campaignIds.includes(parseInt(data.id)));
            dispatch(reduxCampaignPreviewPublishDataAction({ data: filterCampaignData }))
            setPreviewValid(false)
            setCurrent(2)
          }
          // ****************************************************************************************************
          else {
            await dispatch(postCampaignAction({ tenantId, authToken, userId, params, payload: publishData ? publishData.payload : campaignToPublishDetails.payload })).then((data) => {
              const { responseCode: { status = "", msg = "" }, response = [] } = data;
              if (isApiCallSuccess(status)) {
                res = data;
                dispatch(reduxCampaignPreviewPublishDataAction({ data: response }))
                //   If the user has already selected a campign and Validated it now the Button must have changed 
                //  to Publish, but user decides to go back and add another campaign so if the payload
                //  campaiignIds selected arre greater than the previous campaign data length then Published button must be changed to Valid again

                // if (IsPreviewValid && campaignToPublishDetails.payload.campaignIds.length < campaignPublishData.length) {
                // setPreviewValid(true);
                // } else if (flag || campaignToPublishDetails.payload.campaignIds.length > campaignPublishData.length) {
                setPreviewValid(false)
                // }
                if (publishData) {
                  setCurrent(2)
                }
                else {
                  next();
                }
              }
              else {
                message.error(msg ? msg : campaignMessages.error500)
              }
            }).catch((err) => {
              console.log(err);
            })
          }
        } else {
          console.log("List data not found");
        }
      }).catch((err) => {
        console.log(err)
      });

      return res;
    }

    handleThirdPartyApis()
    // } else {
    //   console.log("DATA ALREADY IN REDUX");
    //   next()
    // }
  }

  // console.log("isBasicDetailsComplete:", isBasicDetailsComplete);

  const returnComponent = (type) => {

    // console.log("TYPE", type)
    if (type === 'BasicDetails') {
      return <BasicDetails targetTimeZone={targetTimeZone} onFormCompletion={handleBasicDetailsCompletion} setBasicDetailsInParent={setBasicDetailsInParent} isViewCampaign={isViewCampaign} />;
    } else if (type === 'CustomPlans') {
      return <CustomPlanStrategy targetTimeZone={targetTimeZone} {...props} generateCmpData={generateCampaignDataForPublishPage} handleCampaignForPreview={handleCampaignForPreview} childCampaignData={childCampaignData} isViewCampaign={isViewCampaign} />;
    } else if (type === 'RecommededPlans') {
      return <RecommendedPlans targetTimeZone={targetTimeZone} {...props} isViewCampaign={isViewCampaign} />;
    } else if (type === 'Strategy') {
      return <Strategy {...props} isViewCampaign={isViewCampaign} />;
    } else if (type === 'Creative') {
      return <Creative setCreativePayloadDetails={setCreativePayloadDetails} {...props} isViewCampaign={isViewCampaign} />;
    } else if (type === 'CustomStrategy') {
      return <CustomStrategy next={next} strategyNext={strategyNext} setStrategyNext={setStrategyNext} strategyData={strategyData} setStrategy={setStrategy} setShowStepper={setShowStepper} {...props} isViewCampaign={isViewCampaign} />;
    } else if (type === 'RecommendedStrategy') {
      return <RecommendStrategy targetTimeZone={targetTimeZone} isRecomendedPlanCampaign={isRecomendedPlanCampaign} platformType={"beki"} {...props} strategyNext={strategyNext} setStrategyNext={setStrategyNext} next={next} fetchPreferenceEditDetails={fetchPreferenceEditDetails} fetchStrategyEditDetails={fetchStrategyEditDetails} current={current} isViewCampaign={isViewCampaign} />;
    } else if (type === 'PreviewPublish') {
      return <PreviewPublish campaignSuggestionNameList={campaignSuggestionNameList} campaignIds={campaignId} setPreviewValidateDetails={setPreviewValidateDetails} summary={summary} {...props} isViewCampaign={isViewCampaign} />;
    }
  };


  const pushToPayload = (type, form, status, nameOutsideForm = '', isFrequency = false, isTimeValue = false, keysToDelete = []) => {
    const formData = cloneDeep(form);
    let obj = {
      campaignName: nameOutsideForm.length > 0 ? nameOutsideForm : formData.campaignName,
      type: type,
      startDate: moment(formData.startDate).format('YYYY-MM-DD'),
      endDate: moment(formData.endDate).format('YYYY-MM-DD'),
      totalBudget: parseFloat(formData.budget),
      pacingType: parseInt(formData.pacing),
      duration: formData.duration,
      campaignId: formData.campaignId ? formData.campaignId : null,
      strategyId: formData.strategyId ? formData.strategyId : null,
      status: isRecomendedPlanCampaign ? 3 : status,

    }
    if (isFrequency && formData.selectedFrequencyOption == "limited") {
      obj["freqCap"] = {
        level: parseInt(formData.frequencyCapForLevel),
        cap: parseInt(formData.frequencyCapTo),
        interval: parseInt(formData.frequencyCapPerInterval)
      }
    }
    if (isTimeValue && formData.selectedFrequencyOption == "limited") {
      obj["freqCap"] = {
        level: 2,
        time: parseInt(formData.frequencyCapTime),
        cap: parseInt(formData.frequencyCapTo),
        interval: parseInt(formData.frequencyCapPerInterval)
      }
    }
    if (formData.strategyName) {
      obj["strategyName"] = formData.strategyName
    }
    if (formData.campaignStatus) {
      obj["campaignStatus"] = formData.campaignStatus
    }
    keysToDelete.forEach(key => {
      if (obj.freqCap && obj.freqCap.hasOwnProperty(key)) {
        delete obj["freqCap"][key];
      }
    });
    return obj;
  }


  const handleNextClick = async (publish = false, isDraft = false, isConfirmedReco = false) => {
    // console.log(current, "current")
    // console.log(props, "props")
    // console.log(isConfirmedReco)

    if (isDemoAdvertiser) {
      if (isRecomendedPlanCampaign) {
        if (current == 4) {
          message.info(infoMessages.campaignPublish);
          setIsPublishButton(true);
          return
        }
      } else {

        if (isDraft) {
          message.info(infoMessages.campaignDraft);
          setIsPublishButton(true);
          return
        }

        message.info(infoMessages.campaignPublish);
        setIsPublishButton(true);
        return

      }
    }

    const { match: { params: { id } } } = props;

    if (current == 1) {


      // console.log("campaignId",campaignId)
      // Create the payload based on the adType
      let payload = {
        campaignId: id ? id : campaignId,
        isComplete: 1,
        ads: [],
        meta: [],
        dv360: [],
        ion: [],
        tiktok: [],
        viads: []
      };


      if (isRecomendedPlanCampaign) {

        payload = { ...recommendedPlanData.payload, campaignId: id ? id : campaignId, isComplete: 3, }

        // console.log("123 recommendedPlanData payload", payload)

      }

      else {



        // console.log("123 handleNextClick customDetailsForm", customDetailsForm)

        if (!customDetailsForm.adType.facebookVideo && customDetailsForm.dataForm.facebook.videoForm.form.campaignId) {
          payload.meta.push(pushToPayload(1, customDetailsForm.dataForm.facebook.videoForm.form, 0, customDetailsForm.dataForm.facebook.facebookCampaignName.form.campaignName));
        }

        if (customDetailsForm.adType.facebookDisplay) {
          payload.meta.push(pushToPayload(0, customDetailsForm.dataForm.facebook.displayForm.form, 1, customDetailsForm.dataForm.facebook.facebookCampaignName.form.campaignName));
        }

        if (!customDetailsForm.adType.facebookDisplay && customDetailsForm.dataForm.facebook.displayForm.form.campaignId) {
          payload.meta.push(pushToPayload(0, customDetailsForm.dataForm.facebook.displayForm.form, 0, customDetailsForm.dataForm.facebook.facebookCampaignName.form.campaignName));
        }




        if (customDetailsForm.adType.dv360Video) {
          payload.dv360.push(pushToPayload(1, customDetailsForm.dataForm.dv360.videoForm.form, 1, customDetailsForm.dataForm.dv360.dv360CampaignName.form.campaignName, true, true));
        }

        if (!customDetailsForm.adType.dv360Video && customDetailsForm.dataForm.dv360.videoForm.form.campaignId) {
          payload.dv360.push(pushToPayload(1, customDetailsForm.dataForm.dv360.videoForm.form, 0, customDetailsForm.dataForm.dv360.dv360CampaignName.form.campaignName, true, true));
        }

        if (customDetailsForm.adType.dv360Display) {
          payload.dv360.push(pushToPayload(0, customDetailsForm.dataForm.dv360.displayForm.form, 1, customDetailsForm.dataForm.dv360.dv360CampaignName.form.campaignName, true, true));
        }

        if (!customDetailsForm.adType.dv360Display && customDetailsForm.dataForm.dv360.displayForm.form.campaignId) {
          payload.dv360.push(pushToPayload(0, customDetailsForm.dataForm.dv360.displayForm.form, 0, customDetailsForm.dataForm.dv360.dv360CampaignName.form.campaignName, true, true));
        }

        if (customDetailsForm.adType.tiktokVideo) {
          payload.tiktok.push({
            campaignName: customDetailsForm.dataForm.tiktok.tiktokCampaignName.form.campaignName,
            type: 1,
            startDate: moment(customDetailsForm.dataForm.tiktok.videoForm.form.startDate).format('YYYY-MM-DD'),
            endDate: moment(customDetailsForm.dataForm.tiktok.videoForm.form.endDate).format('YYYY-MM-DD'),
            totalBudget: customDetailsForm.dataForm.tiktok.videoForm.form.budget,
            pacingType: customDetailsForm.dataForm.tiktok.videoForm.form.pacing,
            duration: customDetailsForm.dataForm.tiktok.videoForm.form.duration,
            campaignId: customDetailsForm.dataForm.tiktok.videoForm.form.campaignId ? customDetailsForm.dataForm.tiktok.videoForm.form.campaignId : null,
            strategyId: customDetailsForm.dataForm.tiktok.videoForm.form.strategyId ? customDetailsForm.dataForm.tiktok.videoForm.form.strategyId : null,
          });
        }


        if (customDetailsForm.adType.ionVideo) {
          payload.ion.push(pushToPayload(1, customDetailsForm.dataForm.ion.videoForm.form, 1, '', true, true, ['time']));
        }

        if (!customDetailsForm.adType.ionVideo && customDetailsForm.dataForm.ion.videoForm.form.campaignId) {
          payload.ion.push(pushToPayload(1, customDetailsForm.dataForm.ion.videoForm.form, 0, '', true, true, ['time']));
        }

        if (customDetailsForm.adType.ionDisplay) {
          payload.ion.push(pushToPayload(0, customDetailsForm.dataForm.ion.displayForm.form, 1, '', true, true, ['time']));
        }

        if (!customDetailsForm.adType.ionDisplay && customDetailsForm.dataForm.ion.displayForm.form.campaignId) {
          payload.ion.push(pushToPayload(0, customDetailsForm.dataForm.ion.displayForm.form, 0, '', true, true, ['time']));
        }

        if (customDetailsForm.adType.viVideo) {
          payload.viads.push(pushToPayload(1, customDetailsForm.dataForm.viads.videoForm.form, 1, '', true, true, ['time']));
        }

        if (!customDetailsForm.adType.viVideo && customDetailsForm.dataForm.viads.videoForm.form.campaignId) {
          payload.viads.push(pushToPayload(1, customDetailsForm.dataForm.viads.videoForm.form, 0, '', true, true, ['time']));
        }

        if (customDetailsForm.adType.viDisplay) {
          payload.viads.push(pushToPayload(0, customDetailsForm.dataForm.viads.displayForm.form, 1, '', true, true, ['time']));
        }

        if (!customDetailsForm.adType.viDisplay && customDetailsForm.dataForm.viads.displayForm.form.campaignId) {
          payload.viads.push(pushToPayload(0, customDetailsForm.dataForm.viads.displayForm.form, 0, '', true, true, ['time']));
        }

        // console.log("payload", payload)

        // Sorting function
        const sortByCampaignAndStrategy = (a, b) => {
          const aHasValues = a.campaignId !== null && a.strategyId !== null;
          const bHasValues = b.campaignId !== null && b.strategyId !== null;

          if (aHasValues && !bHasValues) {
            return -1; // a comes first
          } else if (!aHasValues && bHasValues) {
            return 1; // b comes first
          } else {
            return 0; // no preference
          }
        }


        // Sort the meta array
        payload.meta.sort(sortByCampaignAndStrategy);

        // Sort the dv360 array
        payload.dv360.sort(sortByCampaignAndStrategy);

        payload.ion.sort(sortByCampaignAndStrategy);

        payload.tiktok.sort(sortByCampaignAndStrategy);

        payload.viads.sort(sortByCampaignAndStrategy);

        // Sort other arrays if needed

        // console.log("payload", payload);

        // return;

      }
      let params = {}
      if (isConfirmedReco) {
        params["validate"] = true;
      }
      await dispatch(postCustomDetailsAction({ tenantId, authToken, userId, params, payload })).then((data) => {
        const {
          responseCode: { status = "", msg = "", code = 0 },
          responseObj,
        } = data;
        // console.log("data", data)
        // console.log(payload, "payload", params, "params")

        if (status == "Success") {

          // dispatch(
          //   customPlanReduxAction({
          //     customDetailsForm: payload,
          //     customPlanResponse: responseObj
          //   })
          // );

          // if (id) {
          fetchStrategyEditDetails()
          // }
          // else {
          //   setStrategyData(responseObj)
          //   // dispatch(strategyPayloadAction({strategyListData : responseObj}))
          //   // localStorage.setItem('strategyListData', JSON.stringify(responseObj));
          //   dispatch(strategyListReduxAction({
          //     strategyData: responseObj
          //   }));
          // }

          message.success(msg)
          // toast(status, msg);
          next();
        }
        else if (status.toLowerCase() == "fail") {
          if (code == 21014) {
            warningModalRecco(msg);
          }
          else {
            message.error(msg)
          }
        }
        else {
          console.log("Data not found");
        }
      })
        .catch((error) => {
          console.error(error);
        });
    }

    else if (current == 3) {
      saveCreativeStrategy();
    }

    else if ((current == 2 && !isRecomendedPlanCampaign) || (current == 4 && isRecomendedPlanCampaign)) {
      if (publish) {
        publishCampaign();
      }
      else if (isDraft) {
        draftCampaign()
      }
      else {
        // setSubmitValidate(true);
        validateStrategy();
      }
    }

    // Proceed to the next step
    else {
      next();
    }
  };



  const fetchStrategyEditDetails = async (id) => {
    // payload.customerIds = customPlanData.customPlanResponse.customerIds;
    let params = { strategy: 'list', mandateId: id ? id : basicDetailsReduxForm.campaignIdCreated };

    if (isDemoAdvertiser) {
      const { match: { params } } = props;
      if (isDemoCampaign(campaignList, params.id)) {
        if (props.location.pathname.includes('edit-campaign') || props.location.pathname.includes('view-campaign')) {
          const {
            responseCode: { status = "", msg },
            responseObj,
          } = recoCampaignStrategyList;
          setStrategyData(responseObj)
          dispatch(strategyListReduxAction({
            strategyData: responseObj
          }));
          return
        }
      }
    }

    await dispatch(getCampaignListAction({ tenantId, authToken, userId, params })).then((data) => {
      const {
        responseCode: { status = "", msg },
        responseObj,
      } = data;
      // console.log("data", data)

      if (status == "Success") {
        // console.log("responseObj", responseObj)
        setStrategyData(responseObj)
        dispatch(strategyListReduxAction({
          strategyData: responseObj
        }));
      }
      else if (status == "Fail") {
        message.error(msg)
      }
      else {
        console.log("Data not found");
      }
    })
  }


  const fetchPreferenceEditDetails = async (id) => {
    // payload.customerIds = customPlanData.customPlanResponse.customerIds;
    let params = { strategy: 'list', mandateId: id ? id : basicDetailsReduxForm.campaignIdCreated, type: 'reco' };
    if (isDemoAdvertiser) {
      const { match: { params } } = props;
      if (isDemoCampaign(campaignList, params.id)) {
        if (props.location.pathname.includes('edit-campaign') || props.location.pathname.includes('view-campaign')) {
          const { responseObj } = recoCampaignStrategyTypeReco;
          setStrategyData(responseObj)
          dispatch(setPreferenceListReduxAction({
            preferenceData: responseObj
          }));
          return;
        }
      }
    }
    await dispatch(getCampaignListAction({ tenantId, authToken, userId, params })).then((data) => {
      const {
        responseCode: { status = "", msg },
        responseObj,
      } = data;
      // console.log("data", data)

      if (status == "Success") {
        // console.log("responseObj", responseObj)
        setStrategyData(responseObj)
        dispatch(setPreferenceListReduxAction({
          preferenceData: responseObj
        }));

      }
      else if (status == "Fail") {
        message.error(msg)
      }
      else {
        console.log("Data not found");
      }
    })
  }
  const next = () => {
    // setCurrent(prevCurrent => prevCurrent + 1);
    setCurrent(current + 1);
    dispatch(setStepperEditAction({ stepperValue: current + 1, screen: '' }));
  };



  // console.log(current, 'current ******************88')

  const prev = () => {
    if (current == 3) {
      setStrategyNext(0)
    }

    const { location, match: { params: { id } }, history } = props;
    const data = location && location.state && location.state.data ? location.state.data : {};

    if (data && data.objectForCampaignPublish && data.objectForCampaignPublish.redirectScreen && data.objectForCampaignPublish.redirectScreen == 'campaign-list') {
      history.push('/' + routes.mainRoute + '/' + routes.containers.campaignList);
      return;
    }

    setCurrent(current - 1);
  };

  const setStrategy = () => {
    // console.log("current", current)
    setCurrent(2);
  };


  const [campaignSuggestionNameList, setCampaignSuggestionNameList] = useState([]);

  const saveCreativeStrategy = async () => {
    // console.log("creativePayloadDetails", creativePayloadDetails.data)

    if (isDemoAdvertiser) {
      if (props.location.pathname.includes('edit-campaign') || props.location.pathname.includes('view-campaign')) {
        const {
          responseObj,
          responseCode: { status = "", msg = "" },
        } = recoCreativeEditResponse;

        dispatch(
          strategyCreativeDataAction({
            data: creativePayloadDetails.dataForRedux,
          })
        );
        dispatch(
          PreviewDataAction({
            data: responseObj,
          })
        );
        if (isRecomendedPlanCampaign && responseObj && Object.keys(responseObj).length > 0) {
          const { match: { params: { id } }, history, match } = props;

          let campaignPreviewPayload = {
            mandateId: "",
            campaignIds: []
          }
          campaignPreviewPayload.mandateId = id ? id : basicDetailsReduxForm.campaignIdCreated;
          // Iterate through each platform type (ads, meta, dv360)
          Object.keys(responseObj).forEach(platform => {
            responseObj[platform].forEach(item => {
              campaignPreviewPayload.campaignIds.push(item.campaignId);
            });
          });

          const { responseCode: { status = "", msg = "" }, response = [] } = recoCampaignListPreview;
          dispatch(reduxCampaignPreviewPublishDataAction({ data: response }))
          next();
        }

        return
      }
    }

    let params = {
    };
    if (creativePayloadDetails.isAddApi) {
      params["creative"] = "auto"
    }
    else {
      params["creative"] = "edit"
    }

    try {
      await dispatch(
        postCampaignDataAction({
          tenantId,
          authToken,
          userId,
          params,
          payload: creativePayloadDetails.data,
        })
      )
        .then((data) => {
          const {
            responseObj,
            responseCode: { status = "", msg = "" },
          } = data;
          console.log("123--data")
          if (isApiCallSuccess(status)) {
            dispatch(
              strategyCreativeDataAction({
                data: creativePayloadDetails.dataForRedux,
              })
            );
            dispatch(
              PreviewDataAction({
                data: responseObj,
              })
            );
            if (isRecomendedPlanCampaign && responseObj && Object.keys(responseObj).length > 0) {
              const { match: { params: { id } }, history, match } = props;

              let campaignPreviewPayload = {
                mandateId: "",
                campaignIds: []
              }
              campaignPreviewPayload.mandateId = id ? id : basicDetailsReduxForm.campaignIdCreated;
              // Iterate through each platform type (ads, meta, dv360)
              Object.keys(responseObj).forEach(platform => {
                responseObj[platform].forEach(item => {
                  campaignPreviewPayload.campaignIds.push(item.campaignId);
                });
              });

              const params = {
                list: "preview"
              }
              dispatch(getThirdPartyAccountAction({ tenantId, authToken, userId })).then(async (data) => {
                const {
                  responseCode: { status = "" },
                  responseObj,
                } = data;
                if (status === "Success") {
                  dispatch(postCampaignAction({ tenantId, authToken, userId, params, payload: campaignPreviewPayload })).then((data) => {
                    // console.log(data,'campaignToPublishDetails');
                    const { responseCode: { status = "", msg = "" }, response = [] } = data;
                    if (isApiCallSuccess(status)) {
                      dispatch(reduxCampaignPreviewPublishDataAction({ data: response }))
                      next();
                    }
                    else {
                      message.error(msg ? msg : campaignMessages.error500)
                    }
                  }).catch((err) => {
                    console.log(err);
                  })
                }
              })


            }

            // next();
          } else {
            console.log(
              `<========error in campaign -> creative save ===============>${msg}`
            );
          }
        })
        .catch((err) => console.log(err));
    }
    catch (err) {
      console.log(err);
    }
  };

  const validateStrategy = async () => {

    // beki/publish?validate=auto'

    try {
      const x = { campaignNameRequest: previewValidateDetails.campaignNameRequest }
      await dispatch(
        postCampaignNameListAction({
          tenantId,
          authToken,
          userId,
          payload: x,
        })
      )
        .then((data) => {
          const {
            responseObj = [],
            responseCode: { status = "", msg = "" },
          } = data;
          // console.log("123456", data)
          if (isApiCallSuccess(status)) {
            const nameList = []
            Object.keys(responseObj).forEach((item, index) => {
              if (responseObj[item].length > 0) {
                const data = responseObj[item].filter(list => list.exist == 1); // Change this to 1 after mapping successfullys
                data.length > 0 && data.forEach(x => nameList.push({ ...x, platformName: item }))
              }
            })
            // console.log(nameList, "NAEMLSIT");
            if (nameList.length > 0) {
              message.error("Name Already Exists!");
              setPreviewValid(false)
              setCampaignSuggestionNameList(nameList);
            } else {
              // message.success(msg);
              validateForPublish();
            }
            // next();
          } else {
            message.error(msg)
            console.log(
              `<========error in campaign -> NameLIST ===============>${msg}`
            );
          }
        })
        .catch((err) => console.log(err));
    }
    catch (err) {
      console.log(err);
    }
  };

  const validateForPublish = async (isConfirmClick = false) => {
    try {
      const params = {
        validate: "auto",
      };
      if (isRecomendedPlanCampaign || isConfirmClick) {
        params["ignorewarn"] = true
      }
      dispatch(
        postValidateStrategyAction({
          tenantId,
          authToken,
          userId,
          params,
          payload: previewValidateDetails.data,
        })
      ).then((data) => {
        const {
          response,
          responseObj = {},
          responseCode: { status = "", msg = "" },
        } = data;
        if (isApiCallSuccess(status)) {
          setPreviewValid(true);
          setSummary(response)
          message.success(msg)
          // dispatch(
          //   strategyCreativeDataAction({
          //     data: creativePayloadDetails.dataForRedux,
          //   })
          // );
        } else {
          // setAlertState((prevData)=>{
          //   return {
          //     ...prevData,
          //     openAlert:true
          //   }
          // })
          if (responseObj.warnings && responseObj.warnings.length > 0) {
            warningModal(responseObj.warnings);
          }
          else {
            message.error(msg)
          }
          setPreviewValid(false);
        }
      })
    }
    catch (err) {
      console.log(
        `<========error in campaign -> Validate ===============>${err}`
      );
    }
  }

  const publishCampaign = async () => {
    const { match: { params: { id } } } = props;
    const params = {
      publish: "auto",
      mode: "publish",
      mandateId: id ? id : sessionStorage.getItem("campaignIdCreated")
    };

    let payload = {
      campaigns: previewValidateDetails.saveDraft
    }

    if (isStatusChanged) {
      payload["status"] = 1
    }

    // console.log(payload);

    // debugger;
    // return;

    // previewValidateDetails.data.isDraft = 0;

    try {
      await dispatch(
        postValidateStrategyAction({
          tenantId,
          authToken,
          userId,
          params,
          payload: payload,
        })
      )
        .then((data) => {
          const { history } = props;
          const {
            // response = [],
            responseCode: { status = "", msg = "" },
          } = data;
          // console.log("123456", data)
          if (isApiCallSuccess(status)) {
            message.success(msg)
            history.push('/' + routes.mainRoute + '/' + routes.containers.campaignList);
            // next();
          } else {
            message.error(msg)
            console.log(
              `<========error in campaign -> NameLIST ===============>${msg}`
            );
          }
        })
        .catch((err) => console.log(err));
    }
    catch (err) {
      console.log(err);
    }
  };

  const draftCampaign = async () => {
    const { match: { params: { id } } } = props;
    const params = {
      publish: "auto",
      mode: "draft",
      mandateId: id ? id : sessionStorage.getItem("campaignIdCreated")
    };

    previewValidateDetails.data.isDraft = 1;

    try {
      await dispatch(
        postValidateStrategyAction({
          tenantId,
          authToken,
          userId,
          params,
          payload: previewValidateDetails.saveDraft,
        })
      )
        .then((data) => {
          const {
            // response = [],
            responseCode: { status = "", msg = "" },
          } = data;
          // console.log("123456", data)
          if (isApiCallSuccess(status)) {
            message.success(msg)
            // next();
          } else {
            message.error(msg)
            console.log(
              `<========error in campaign ->  ===============>${msg}`
            );
          }
        })
        .catch((err) => console.log(err));
    }
    catch (err) {
      console.log(err);
    }
  };

  // Define design tokens for Steps
  const stepsDesignTokens = {
    fontSize: token.fontSizeSM, // Modify the text size
    colorText: token.colorPrimary, // Change the text color
    dotSize: token.iconSizeSM, // Adjust the dot size
    dotCurrentSize: token.dotCurrentSize, // Adjust the current dot size
  };

  // Apply design tokens to the Steps component
  theme.useToken(stepsDesignTokens);

  const contentStyle = {
    // lineHeight: '260px',
    // textAlign: 'center',
    padding: 20,
    // margin: 20,
    color: token.colorTextTertiary,
    // backgroundColor: token.colorFillAlter,
    backgroundColor: "#fff",
    borderRadius: '8px 8px 0px 0px',
    // border: `1px solid ${token.colorBorder}`,
    // marginTop: 16,
    marginBottom: 0,
    // boxShadow: "4px 4px 15px 0 #00000033",
    height: 468,
    overflowY: 'scroll',

  };

  const renderButtonStyle = {
    padding: '17px 3em',
    background: "#EBF1FA",
    borderTop: "1px solid #DCE3EE",
    borderBottom: "1px solid #DCE3EE",
    borderRadius: "0px 0px 10px 10px",
  }

  const previewPublishStyle = {
    padding: 20
  };

  const isRecommendedPlanStyle = {
    overflowX: 'hidden',
  };
  const setPreferenceStyle = {
    height: "70vh",
    paddingBottom: 55,
    borderRadius: 10
  }
  const isRenderButtonStyle = {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0
  }



  // console.log("current", current)
  // console.log("steps", steps)


  const saveBasicDetails = async () => {
    const { match: { params: { id } } } = props;

    let params = { addup: 'auto' };
    let payload = {
      isComplete: isRecomendedPlanCampaign ? 3 : 1,
      isReco: isRecomendedPlanCampaign ? 1 : 0,
      totalBudget: basicDetailsForm.totalBudget,
      campaignName: basicDetailsForm.campaignName,
      brandName: basicDetailsForm.brandName,
      goal: basicDetailsForm.goal,
      goalValue: basicDetailsForm.goalValue,
      // startDate: moment(basicDetailsForm.startDate).format('YYYY-MM-DD'),
      // endDate: moment(basicDetailsForm.endDate).format('YYYY-MM-DD'),
      startDate: basicDetailsForm.isStartDateChanged ? getUserSelectedDateInUtc({ date: basicDetailsForm.startDate, targetTimeZone: targetTimeZone, isStartDate: true }) : basicDetailsForm.fetchedStartDate,
      endDate: basicDetailsForm.isEndDateChanged ? getUserSelectedDateInUtcForEndDate({ date: basicDetailsForm.endDate, targetTimeZone: targetTimeZone, isStartDate: false }) : basicDetailsForm.fetchedEndDate,
      businessType: basicDetailsForm.businessType,
      brandUrl: basicDetailsForm.brandUrl,
      category: basicDetailsForm.category,
      subcategory: basicDetailsForm.subcategory,
      advId: tenantId,
      isRecActive: id ? basicDetailsForm.isRecActive : isRecomendedPlanCampaign ? 3 : 2
    }



    // console.log("payload", payload)

    // return;

    if (basicDetailsReduxForm && Object.keys(basicDetailsReduxForm).length > 0) {
      params.addup = basicDetailsReduxForm.campaignIdCreated;
      payload.id = basicDetailsReduxForm.campaignIdCreated;
    }
    dispatch(reduxCampaignDataAction({ data: null }));
    dispatch(reduxDataForAccordianOpenCampaignAction({ data: null }));

    if (isDemoAdvertiser) {
      if (props.location.pathname.includes("edit-campaign") || props.location.pathname.includes("view-campaign")) {
        let basicDetailsData = { ...basicDetailsForm, campaignIdCreated: basicDetailsForm.campaignId };
        dispatch(
          basicDetailsReduxAction({
            basicDetailsForm: basicDetailsData
          })
        );
        setCampaignId(basicDetailsForm.campaignId);
        sessionStorage.setItem('campaignIdCreated', JSON.stringify(basicDetailsForm.campaignId));
        next();
        return
      } else {
        saveBasicDetails()
      }
    } else {
      if (!isViewCampaign) {
        saveBasicDetails()
      } else {
        next();
      }
    }

    async function saveBasicDetails() {
      await dispatch(postBasicDetailsSubmitAction({ tenantId, authToken, userId, params, payload })).then((data) => {
        const {
          responseCode: { status = "", msg },
          responseObj,
        } = data;
        // console.log("data", data)

        if (status == "Success") {
          let basicDetailsData = { ...basicDetailsForm, campaignIdCreated: responseObj };
          dispatch(
            basicDetailsReduxAction({
              basicDetailsForm: basicDetailsData
            })
          );
          // setBasicDetalsSubmit(response);
          setCampaignId(responseObj);
          sessionStorage.setItem('campaignIdCreated', JSON.stringify(responseObj));
          message.success(msg)
          next();
        }
        else if (status == "Fail") {
          toast(status, msg)
        }
        else {
          console.log("Data not found");
        }
      })
        .catch((error) => {
          console.error(error);
        });
    }
  };



  const toast = (status, msg, type) => {
    setEnableToast(true);
    setToastStatus(status);
    setToastMsg(msg);
    return;
  }

  const handleToastStatus = async (status) => {
    setEnableToast(status);
    // listCampaign();


  };

  const confirmationCallbackModel = () => {
    setEnableToast(false);

    // if (method === "recActiveStatus") {
    //   handleStatusUpdate();
    // }
  };

  // Determine whether to use regular steps or recommended steps
  const isRecommendedPlan = isRecomendedPlanCampaign;
  const stepsToUse = isRecomendedPlanCampaign ? RecommendedSteps : steps;

  const items = stepsToUse.map((item) => ({
    key: item.title,
    title: item.title,
  }));

  const calculateStepsPadding = () => {
    return isRecomendedPlanCampaign ? '17px 4em' : '17px 10em';
  };


  const renderButtons = (current, prev, handleNextClick, saveBasicDetails, isBasicDetailsComplete) => {
    return (
      // <div style={{ marginTop: -5, display: "flex", justifyContent: "end", padding: "0 20px 20px 0" }}>
      // {current > 0 && <Button style={{ margin: '0 8px' }} onClick={() => prev()} disabled={localStorage.getItem('isRecommendedPlan') === 'true' && current == 2 }>Back</Button>}
      // {current === 0 && <Link to={`/${routes.mainRoute}/${routes.containers.campaignList}`}><button type="button" className="btn btn-primary btn-primary-padding br-8 mr-2">Back</button></Link>}
      // {current < steps.length - 1 && current !== 0 && current != 3 && <Button style={{ fontFamily: '"poppins", sans-serif' }} type="primary" onClick={() => (current == 2 ? strNext() : current == 1 ? handleNextClick() : next())}>{localStorage.getItem('isRecommendedPlan') === 'true' && current == 1 ? 'Continue with Recommended Plan' : 'Next'}</Button>}
      // <div style={{ marginTop: -5, display: "flex", justifyContent: "end", padding: "0" }}>
      //   {current > 1 && childCampaignData.isChildEdit &&  localStorage.getItem('isRecommendedPlan') != 'true' && <Button style={{ margin: '0 8px' }} onClick={() => prev()}>Back</Button>}
      //   {current > 0 && !childCampaignData.isChildEdit &&  localStorage.getItem('isRecommendedPlan') != 'true' && <Button style={{ margin: '0 8px' }} onClick={() => prev()}>Back</Button>}
      //   {current > 0 &&  localStorage.getItem('isRecommendedPlan') == 'true' && <Button style={{ margin: '0 8px' }} onClick={() => prev()}>Back</Button>}
      //   {current === 0 && <Link to={`/${routes.mainRoute}/${routes.containers.campaignList}`}><button type="button" className="btn btn-primary btn-primary-padding br-8 mr-2">Back</button></Link>}
      //   {current < stepsToUse.length - 1 && current !== 0 && current != 3 && localStorage.getItem('isRecommendedPlan') == 'true' && <Button style={{ fontFamily: '"poppins", sans-serif' }} type="primary" onClick={() => (current == 2 ? strNext() : current == 1 ? handleNextClick() : next())}>{localStorage.getItem('isRecommendedPlan') === 'true' ? 'Continue with Recommended Plan' : 'Next'}</Button>}
      //   {/* {current < steps.length - 1 && current === 0 && <Button style={{ fontFamily: '"poppins", sans-serif' }} type="primary" onClick={() => next()}>{localStorage.getItem('isRecommendedPlan') === 'true' ? 'Next' : 'Generate Media Plan'}</Button>} */}
      //   {current == 1  && localStorage.getItem('isRecommendedPlan') != 'true' && <Button disabled={!campaignToPublishDetails.isSaveEnabled} onClick={()=>{handleCampaignForPreview()}} style={{ fontFamily: '"poppins", sans-serif' }} type="primary">Save & Next</Button>}
      //   {current < stepsToUse.length - 1 && current === 0 && <Button style={{ fontFamily: '"poppins", sans-serif' }} type="primary"
      //     disabled={!isBasicDetailsComplete}
      //     onClick={() => saveBasicDetails()}>{localStorage.getItem('isRecommendedPlan') === 'true' ? 'Next' : 'Next'}</Button>}
      //   {current < stepsToUse.length - 1 && current == 3 && <Button disabled={!creativePayloadDetails.valid} style={{ fontFamily: '"poppins", sans-serif' }} type="primary" onClick={() => { handleNextClick(); }}> Next</Button>}
      //   {current === stepsToUse.length - 1 && <Button className="mr-2" type="primary" onClick={() => handleNextClick(false, true)}>Save as Draft</Button>}
      //   {current === stepsToUse.length - 1 && !IsPreviewValid && <Button disabled={previewValidateDetails.data.length == 0 || previewValidateDetails.totalPlatforms !== previewValidateDetails.totalPlatformNumbers} type="primary" onClick={() => handleNextClick()}>Validate</Button>}
      //   {current === stepsToUse.length - 1 && IsPreviewValid && <Button type="primary" onClick={() => handleNextClick(true)}>Publish</Button>}
      // </div>


      <div style={{ marginTop: -5, display: "flex", justifyContent: "end", padding: "0" }}>
        {current > 1 && childCampaignData.isChildEdit && !isRecomendedPlanCampaign && <Button style={{ margin: '0 8px' }} onClick={() => prev()}>Back</Button>}
        {current > 0 && !childCampaignData.isChildEdit && !isRecomendedPlanCampaign && <Button style={{ margin: '0 8px' }} onClick={() => prev()}>Back</Button>}
        {current > 0 && isRecomendedPlanCampaign && <Button disabled={isRecomendedPlanCampaign && current == 2} style={{ margin: '0 8px' }} onClick={() => prev()}>Back</Button>}
        {current === 0 && <Link to={`/${routes.mainRoute}/${routes.containers.campaignList}`}><button type="button" className="btn btn-primary btn-primary-padding br-8 mr-2">Back</button></Link>}
        {current < stepsToUse.length - 1 && current !== 0 && current != 3 && isRecomendedPlanCampaign && <Button disabled={current == 1 && isViewCampaign} style={{ fontFamily: '"poppins", sans-serif' }} type="primary" onClick={() => (current == 2 ? strNext() : current == 1 ? handleNextClick() : next())}>{isRecomendedPlanCampaign && current == 1 ? 'Continue with Recommended Plan' : 'Next'}</Button>}
        {current == 1 && !isRecomendedPlanCampaign && <Button disabled={!campaignToPublishDetails.isSaveEnabled} onClick={() => { setIsStatusChanged(false); handleCampaignForPreview() }} style={{ fontFamily: '"poppins", sans-serif' }} type="primary">{isViewCampaign ? 'Next' : 'Save & Next'}</Button>}
        {current < stepsToUse.length - 1 && current === 0 && <Button style={{ fontFamily: '"poppins", sans-serif' }} type="primary"
          disabled={!isBasicDetailsComplete}
          onClick={() => saveBasicDetails()}>{isRecomendedPlanCampaign ? 'Next' : 'Next'}</Button>}
        {current < stepsToUse.length - 1 && current == 3 && <Button disabled={!creativePayloadDetails.valid} style={{ fontFamily: '"poppins", sans-serif' }} type="primary" onClick={() => { handleNextClick(); }}> Next</Button>}
        {current === stepsToUse.length - 1 && !isViewCampaign && <Button disabled={!previewValidateDetails.saveDraft.every(obj => obj.hasOwnProperty("accountId"))} className="mr-2" type="primary" onClick={() => handleNextClick(false, true)}>Save as Draft</Button>}
        {current === stepsToUse.length - 1 && !IsPreviewValid && !isViewCampaign && <Button disabled={
          isDemoAdvertiser ? false :
            !previewValidateDetails.data.every(obj => obj.hasOwnProperty("accountId"))
        } type="primary" onClick={() => handleNextClick()}>{isPublishButton ? "Publish" : "Validate"}</Button>}
        {current === stepsToUse.length - 1 && IsPreviewValid && <Button disabled={!previewValidateDetails.data.every(obj => !expiredSeatIds.includes(obj['accountId']))} type="primary" onClick={() => handleNextClick(true)}>Publish</Button>}
      </div>



    )
  };

  const strNext = () => {
    // console.log("setStrategyNext", strategyNext)
    setStrategyNext(strategyNext + 1);
  }

  const warningModal = (data = []) => {
    Modal.confirm({
      title: 'Warning',
      centered: true,
      width: 1000,
      okText: 'Confirm',
      // okType: 'danger',
      cancelText: 'Cancel',
      content: (
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
          {
            data.map((item, index) => (<p key={index}>{item}</p>))
          }
        </div>
      ),
      onOk() {
        setPreviewValid(true);
        validateForPublish(true);
      },
      onCancel() {
        setPreviewValid(false);
      }
    });
  };

  const warningModalRecco = (msg = "") => {
    Modal.confirm({
      title: 'Warning',
      centered: true,
      width: 1000,
      okText: 'Confirm',
      // okType: 'danger',
      cancelText: 'Cancel',
      content: (
        <div style={{ maxHeight: 300, overflowY: 'auto' }}>
          <p>{msg}</p>
        </div>
      ),
      onOk() {
        handleNextClick(false, false, true)
      },
      onCancel() {
      }
    });
  };

  return (
    <>
      {
        enableToast && <ToastModal
          enableToast={enableToast}
          status={toastStatus}
          msg={toastMsg}
          // path={routes.containers.admin + '/' + routes.admin.account.name}
          idProps={props}
          handleConfirmation={confirmationCallbackModel}
          handleToastStatus={handleToastStatus}
          confirmationMsg={confirmationMsg}
          poc={true}
          outSideClickEnable={false}
        />
      }
      <div className="main-panel ion campaign-list">
        <div className="content-wrapper">
          {/* <BreadCrumb /> */}
          <div className="row mt-3 parentDiv">

            <div className='campaign-adj form__style'>

              {/* <div
                style={{
                  marginTop: -5,
                  display: "flex",
                  justifyContent: "end",
                  padding: "0 20px 20px 0"
                }}
              >
                {current > 0 && (
                  <Button
                    style={{
                      margin: '0 8px',
                    }}
                    onClick={() => prev()}
                  >
                    Back
                  </Button>
                )}

                {current < steps.length - 1 && current == !0 && (
                  <Button style={{ fontFamily: '"poppins", sans-serif' }} type="primary" onClick={() => handleNextClick()}>
                    {"Next"}
                  </Button>
                )}

                {current < steps.length - 1 && current == 0 && (
                  <Button style={{ fontFamily: '"poppins", sans-serif' }} type="primary" onClick={() => saveBasicDetails()}
                  disabled={!isBasicDetailsComplete} // Disable the button if BasicDetails form is not complete
                  >
                    Generate Media Plan
                  </Button>
                )}


                {current === steps.length - 1 && (
                  <Button type="primary" onClick={() => message.success('Processing complete!')}>
                    Done
                  </Button>
                )}

              </div> */}

              {
                reduxStrategyData && reduxStrategyData.isStrategyOpen ?
                  <AddNewStrategy targetTimeZone={targetTimeZone} isViewCampaign={isViewCampaign} /> :
                  <div style={{ border: '1px solid #C4CCD8', boxShadow: '4px 4px 15px 0px #00000033', borderRadius: 11, height: (isRecomendedPlanCampaign && current == 2) ? "80vh" : 600, position: "relative" }}>

                    {showStepper &&
                      <>
                        <div style={{
                          padding: calculateStepsPadding(),
                          background: "#EBF1FA",
                          borderTop: "1px solid #DCE3EE",
                          borderBottom: "1px solid #DCE3EE",
                          borderRadius: "10px 10px 0px 0px",
                          transition: 'ease-in 0.5s'
                          // margin: "0px 20px",
                        }}>
                          <Steps className="steps-adj" style={{ fontFamily: '"poppins", sans-serif' }} current={current} items={items} />
                          {/* <Steps className="steps-adj" style={{ fontFamily: '"poppins", sans-serif' }} current={current}>
                            {items.map((item) => (
                              <Steps.Step key={item.key} title={item.title} />
                            ))}
                          </Steps> */}

                        </div>

                      </>
                    }


                    {current !== undefined && stepsToUse[current] !== undefined && (
                      <>
                        <div style=
                          {{
                            ...contentStyle, ...(current === 4 && previewPublishStyle),
                            ...(isRecomendedPlanCampaign && isRecommendedPlanStyle),
                            ...(isRecomendedPlanCampaign && current == 2) && setPreferenceStyle
                          }}>
                          {returnComponent(stepsToUse[current].content)}
                        </div>
                      </>
                    )}
                    <div style={{
                      ...renderButtonStyle, ...(isRecomendedPlanCampaign && current == 2) && isRenderButtonStyle
                    }}>
                      {renderButtons(current, prev, handleNextClick, saveBasicDetails, isBasicDetailsComplete)}
                    </div>
                  </div>
              }

            </div>
          </div>
        </div>
      </div>


    </>
  );
};

export default withRouter(
  connect(
    (state) => ({
      tenantId: get(state, "app.preSignInState.tenantId", ""),
      userId: get(state, "app.preSignInData.userId", ""),
      authToken: get(state, "app.signInData.authToken", ""),
    }),
    {
      getCampaignAction
    }
  )(App)
);
